import React, {Component} from 'react';

class Version extends Component {
    render() {
        return (
            <div className="version" style={{visibility: this.props.visible ? "visible" : "hidden"}}>
                {this.props.version}
            </div>
        )
    }
}

export default Version